/* =============================================================================
   Notable dateless sales — curated, each with its source and pricing basis.

   Ruling (Phase 3 data definition, approved): the Dateless Reference uses ONE
   pricing basis, the PlateX verified corpus all-in buyer cost. Where a widely
   reported figure differs materially, the methodology note explains it rather
   than the figure switching. Sales outside the corpus's source coverage are
   labelled reported results, never blended silently.

   Figures verified against
   platex-index/extraction/out/dateless_structural_classification.csv
   (25 O, 51 NGH) and publicly reported results (1 F; outside the corpus,
   whose sources do not yet include Sotheby's).
   ========================================================================== */

export interface NotableSale {
  plate: string;
  price: string;
  when: string;
  note: string;
  basis: 'verified-corpus' | 'reported';
  basisLabel: string;
}

export const NOTABLE_SALES: NotableSale[] = [
  {
    plate: '1 F',
    price: '£926,000',
    when: 'Sotheby’s London · Nov 2025',
    note: 'The UK record, an Essex mark issued in 1957; the closest a British plate has come to £1m.',
    basis: 'reported',
    basisLabel: 'Reported result',
  },
  {
    plate: '25 O',
    price: '£513,680',
    when: 'DVLA auction · Nov 2014',
    note: 'The DVLA’s most expensive sale; a Birmingham mark, later worn by a Ferrari 250.',
    basis: 'verified-corpus',
    basisLabel: 'Verified corpus',
  },
  {
    plate: '51 NGH',
    price: '£258,164',
    when: 'Apr 2006',
    note: 'A reversed three-letter dateless mark.',
    basis: 'verified-corpus',
    basisLabel: 'Verified corpus',
  },
];
